import { render, staticRenderFns } from "./yibaoDialog.vue?vue&type=template&id=5ff8e05b&scoped=true"
import script from "./yibaoDialog.vue?vue&type=script&lang=js"
export * from "./yibaoDialog.vue?vue&type=script&lang=js"
import style0 from "./yibaoDialog.vue?vue&type=style&index=0&id=5ff8e05b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff8e05b",
  null
  
)

export default component.exports